import texts from '~/utils/texts.json';

function getNestedValue(obj: Record<string, unknown>, path: string): string {
  const keys = path.split('.');
  let result: unknown = obj;

  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = (result as Record<string, unknown>)[key];
    } else {
      return path;
    }
  }

  return typeof result === 'string' ? result : path;
}

function interpolate(
  text: string,
  params?: Record<string, string | number>,
): string {
  if (!params) return text;

  return text.replace(/\{(\w+)\}/g, (_, key) => {
    return params[key] !== undefined ? String(params[key]) : `{${key}}`;
  });
}

function pluralize(text: string, count: number): string {
  const parts = text.split('|').map((s) => s.trim());

  return parts.length > 1 && count !== 1 ? parts[1] : parts[0];
}

/**
 * Função de tradução para textos em português
 */
export const $t = (
  key: string,
  countOrParams?: number | Record<string, string | number>,
  params?: Record<string, string | number>,
): string => {
  const text = getNestedValue(texts, key);

  if (typeof countOrParams === 'number') {
    return interpolate(pluralize(text, countOrParams), {
      count: countOrParams,
      ...params,
    });
  }

  return interpolate(text, countOrParams);
};

/**
 * Composable para acessar textos em componentes Vue
 */
export const useTexts = () => ({ t: $t, texts });

export { texts };
